<template>
<div>
    <div v-if="editing">
        <ImageUpload
            :file-path="component.file"
            @uploadCompleted="storeFile"
            @fileDeleted="deleteFile"
            context="component.image"
        ></ImageUpload>
    </div>
    <div v-else-if="component.file" class="text-center">
        <img :src="`https://skyier-bucket.s3.eu-west-1.amazonaws.com/${component.file}`" alt="" class="img-fluid" style="max-height: 200px;">
    </div>
</div>
</template>

<script>
import route from './../../routes.js'
import ImageUpload from './../ImageUpload'

export default {
    components: {
        ImageUpload,
    },
    props: [
        'component',
        'editing',
    ],
    data(){return {
    }},
    mounted(){
    },
    methods: {
        deleteFile() {
            this.component.file = null
            this.$emit('fileDeleted')
        },
        storeFile(filePath) {
            this.component.file = filePath
            this.$emit('fileUploaded')
        },
        img(url){
            if (!url) {
                return false
            }
            return route.image(url)
        },
    },
}
</script>

<style>
</style>